<template>

  <div class="grid grid-cols-4 gap-x-4 gap-y-4">
    <div class="col-span-4 md:col-span-2 lg:col-span-3">
      <div class="map-container relative h-[500px] rounded-md overflow-hidden">
        <div
            class="absolute z-20 top-0 left-2 bg-white/90 rounded-lg border border-green-900/20 p-2 px-3 mt-2 inline-flex flex-col">
          <h3 class="font-title mb-2 text-[19px]">School type</h3>
          <div class=" flex gap-x-4 ">
            <div>
              <label class="cursor-pointer inline-flex items-center">
                <input type="radio" name="schoolType" value="all" v-model="selectedFilter" class="custom-radio">
                <span class="ml-2">All</span>
              </label>
            </div>
            <div>
              <label class="cursor-pointer inline-flex items-center">
                <input type="radio" name="schoolType" value="primaries" v-model="selectedFilter" class="custom-radio">
                <span class="ml-2">Primaries</span>
              </label>
            </div>
            <div>
              <label class="cursor-pointer inline-flex items-center">
                <input type="radio" name="schoolType" value="secondaries" v-model="selectedFilter" class="custom-radio">
                <span class="ml-2">Secondaries</span>
              </label>
            </div>
          </div>
        </div>
        <MapboxMap
            access-token="pk.eyJ1IjoiYmxlZXBzYW5kYmxvcHMiLCJhIjoicThVQkVabyJ9.nG87Cw1rVP5N5Q5_kgKbVg"
            map-style="mapbox://styles/mapbox/streets-v11"
            :center="mapCenter"
            :cooperative-gestures="true"
            :zoom="[12]"
            style="height: 500px"
            @mb-created="(mapInstance) => map = mapInstance"
        >
          <!--          <MapboxMarker   mb-open="selectedSchool = marker" :key="marker.title" :color="marker.type == 'primary' ? '#0000FF' : '#FF0000'"-->
          <!--                        v-for="marker in markers" :lng-lat="[marker.position[0], marker.position[1]]" popup>-->
          <!--            <template @click="console.log('hello')" mb-open="selectedSchool = marker" #popup>-->
          <!--              <div class="text-[18px] font-title">-->
          <!--                {{ marker.title }}-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </MapboxMarker>-->
          <!--          <MapboxPopup :key="marker.title" :renderless="true"  v-for="marker in markers" :lng-lat="[marker.position[0], marker.position[1]]">-->
          <!--            <div class="text-[18px] font-title">-->
          <!--              {{ marker.title }}-->
          <!--            </div>-->
          <!--          </MapboxPopup>-->

          <!--      <MapboxMarker position="[0, 0]" />-->
        </MapboxMap>
      </div>
    </div>
    <div class="col-span-4 md:col-span-2 lg:col-span-1">
      <div class="mb-4 bg-white/90 p-2 rounded-md">
        <div class="mb-1 flex items-center justify-between">
          <label for="schoolSearch" class="block font-title text-[20px] font-medium text-gray-700 mb-1">Search
            Schools</label>
        </div>
        <div class="flex items-center justify-between gap-x-2">
          <input
              id="schoolSearch"
              v-model="searchTerm"
              type="text"
              placeholder="Enter school name..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
          />
          <button :class="{'opacity-0': searchTerm == ''}"
                  class="text-sm rounded-md bg-white px-2 border py-1 uppercase" @click="clearSearch()">Clear
          </button>
        </div>
        <!-- School List -->
        <div v-if="filteredSchools.length > 0 && searchTerm.trim() !== ''"
             class="mt-2 max-h-60 overflow-y-auto border border-gray-200 rounded-md">
          <ul class="divide-y divide-gray-200">
            <li
                v-for="school in filteredSchools"
                :key="school.urn"
                @click="selectedSchool = school; map.flyTo({ center: school.position })"
                class="p-2 bg-white hover:bg-white/70 cursor-pointer"
                :class="{'bg-white/70': selectedSchool && selectedSchool.urn === school.urn}"
            >
              <div class=" text-[12px] tracking-wider uppercase text-gray-500 ">{{ school.type }}</div>
              <div class="text-[22px] leading-tight font-medium font-title">{{ school.title }}</div>

            </li>
          </ul>
        </div>
        <div v-else-if="searchTerm.trim() !== '' && filteredSchools.length === 0"
             class="mt-2 p-2 text-center text-gray-500 text-sm border bg-white border-gray-200 rounded-md">
          No schools found matching your search
        </div>
      </div>

      <div v-if="selectedSchool" class="fixed pr-10 sm:pr-3 z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[80%] bg-white/90
      sm:relative sm:top-initial sm:left-initial  sm:translate-x-0 sm:translate-y-0  sm:w-auto sm:left-0 sm:top-0
      sm:bg-white/90  rounded-md p-2 px-3 border border-green-900/20">
        <div class="mb-0 text-[12px] tracking-wider uppercase">{{ selectedSchool.type }}</div>
        <h2 class="font-title text-[26px] leading-tight font-bold ">
          {{ selectedSchool.title }}&nbsp;<a class="inline-block ml-2 hover:underline" target="_blank"
                                             :href="selectedSchool.website"><img class="inline w-6" alt="Website link"
                                                                                 src="/img/link.svg"/></a>
        </h2>
        <div class="mt-2 uppercase font-title text-black/40 text-[16px]">Pupil number</div>
        <div>{{ selectedSchool.pupilNumber }}</div>
        <div class="mt-2 uppercase font-title text-black/40 text-[16px]">Smartphone Policy</div>
        <div v-if="selectedSchool.fullyFree" class="flex items-center gap-x-2 font-medium text-center">
          <img class="w-5" src="/img/star.png" alt="Star"/> Fully smartphone-free
          <img class="w-5" src="/img/star.png" alt="Star"/>
        </div>
        <div class="g--copy g--copy--map" v-if="selectedSchool.policy" v-html="selectedSchool.policy"></div>
        <div v-else>No data yet. <a class="underline" href="mailto:hello@sfcbrighton.co.uk">Let us know!</a></div>
        <div class="mt-2 uppercase font-title text-black/40 text-[16px]">Parent pacts signed (Mar 26)</div>
        <div v-if="selectedSchool.parentPactsSigned">{{ selectedSchool.parentPactsSigned }}</div>
        <div v-else>No info.</div>

        <!--        <div class="mt-2 uppercase font-title text-black/40 text-[14px]">Policy link</div>-->
        <!--        <div><a class="hover:underline" href="#">www.placeholder.com</a></div>-->
        <!--        <div class="mt-2 uppercase font-title text-black/40 text-[14px]">Letter sent to parents</div>-->
        <!--        <div>Link</div>-->
        <button class="absolute sm:hidden top-2 right-2" @click="clearSearch()"><img class="w-10" src="/img/close.svg"
                                                                                     alt="Close"></button>
      </div>
    </div>
  </div>

</template>

<script setup>
// import '@mapbox-gl/dist/mapbox-gl.css';
import { MapboxMap, MapboxMarker, MapboxPopup } from '@studiometa/vue-mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import { onMounted, ref, useTemplateRef, watch } from 'vue';

const map = ref(null);
const mapCenter = ref([-0.167830, 50.840219]);
const selectedFilter = ref('all');

const allMarkers = ref([]);
const markers = ref([]);

const searchTerm = ref('');
const filteredSchools = ref([]);

const selectedSchool = ref(null);
const filter = (type) => {
  if (!map.value || !map.value.getLayer('primaries') || !map.value.getLayer('secondaries')) {
    return;
  }

  // First apply type filter to map layers
  if (type === 'primaries') {
    map.value.setLayoutProperty('secondaries', 'visibility', 'none');
    map.value.setLayoutProperty('fullysecondaries', 'visibility', 'none');
    // map.value.setLayoutProperty('current-selected-star-secondary', 'visibility', 'none');
    map.value.setLayoutProperty('primaries', 'visibility', 'visible');
    map.value.setLayoutProperty('fullyprimaries', 'visibility', 'visible');
    // map.value.setLayoutProperty('current-selected-star-primary', 'visibility', 'visible');
  } else if (type === 'secondaries') {
    map.value.setLayoutProperty('primaries', 'visibility', 'none');
    map.value.setLayoutProperty('fullyprimaries', 'visibility', 'none');
    // map.value.setLayoutProperty('current-selected-star-primary', 'visibility', 'none');
    map.value.setLayoutProperty('secondaries', 'visibility', 'visible');
    map.value.setLayoutProperty('fullysecondaries', 'visibility', 'visible');
    // map.value.setLayoutProperty('current-selected-star-secondary', 'visibility', 'visible');
  } else {
    map.value.setLayoutProperty('primaries', 'visibility', 'visible');
    map.value.setLayoutProperty('fullyprimaries', 'visibility', 'visible');
    map.value.setLayoutProperty('secondaries', 'visibility', 'visible');
    map.value.setLayoutProperty('fullysecondaries', 'visibility', 'visible');
    // map.value.setLayoutProperty('current-selected-star-primary', 'visibility', 'visible');
    // map.value.setLayoutProperty('current-selected-star-secondary', 'visibility', 'visible');

  }

  // Then apply search filter to filteredSchools
  if (searchTerm.value.trim() === '') {
    // If no search term, filter only by type
    if (type === 'primaries') {
      filteredSchools.value = allMarkers.value.filter(marker => marker.type === 'primary');
    } else if (type === 'secondaries') {
      filteredSchools.value = allMarkers.value.filter(marker => marker.type === 'secondary');
    } else {
      filteredSchools.value = allMarkers.value;
    }
  } else {
    // If there's a search term, filter by both type and search term
    selectedSchool.value = null;
    const searchFilter = (school) => school.title.toLowerCase().includes(searchTerm.value.toLowerCase());

    if (type === 'primaries') {
      filteredSchools.value = allMarkers.value.filter(marker => marker.type === 'primary' && searchFilter(marker));
    } else if (type === 'secondaries') {
      filteredSchools.value = allMarkers.value.filter(marker => marker.type === 'secondary' && searchFilter(marker));
    } else {
      filteredSchools.value = allMarkers.value.filter(searchFilter);
    }
  }

  // Update map sources with filtered schools
  updateMapSources();
};

onMounted(() => {
  console.log('Component mounted');
  // Initialize with all schools
  filter('all');
  loadSchools();
});

// Watch for changes in the selected filter and apply filtering
watch(selectedFilter, (newValue) => {
  filter(newValue);
});

// Watch for changes in the search term and filter schools
watch(searchTerm, (newValue) => {
  // Re-apply the current filter which will handle both type and search filtering
  filter(selectedFilter.value);
});

const radius = ref(8);
const starSize = ref(0.1);

const updateMapSources = () => {
  if (!map.value || !map.value.getSource('primaries') || !map.value.getSource('secondaries')) {
    return;
  }

  const featuresPrimaries = filteredSchools.value.filter(marker => marker.type === 'primary').map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));

  const featuresSecondaries = filteredSchools.value.filter(marker => marker.type === 'secondary').map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));


  const featuresFullyPrimaries = filteredSchools.value.filter(marker => (marker.fullyFree && marker.type === 'primary')).map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));
  const featuresFullySecondaries = filteredSchools.value.filter(marker => (marker.fullyFree && marker.type === 'secondary')).map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));

  map.value.getSource('primaries').setData({
    'type': 'FeatureCollection',
    'features': featuresPrimaries
  });

  map.value.getSource('secondaries').setData({
    'type': 'FeatureCollection',
    'features': featuresSecondaries
  });

  map.value.getSource('fullyprimaries').setData({
    'type': 'FeatureCollection',
    'features': featuresFullyPrimaries
  });
  map.value.getSource('fullysecondaries').setData({
    'type': 'FeatureCollection',
    'features': featuresFullySecondaries
  });
};

const loadSchools = () => {
// /api/schools
  fetch('/api/schools')
      .then(response => response.json())
      .then(data => {
        console.log(data.schools);
        allMarkers.value = data.schools;
        filteredSchools.value = data.schools; // Initialize filteredSchools with all schools
        console.log(allMarkers.value);
        markers.value = allMarkers.value;
        addMapSource();
      })
      .catch(error => {
        console.error('Error loading schools:', error);
      });
};

const addMapSource = () => {
  const featuresPrimaries = allMarkers.value.filter(marker => marker.type === 'primary').map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));

  const featuresSecondaries = allMarkers.value.filter(marker => marker.type === 'secondary').map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));

  const featuresFullyPrimaries = allMarkers.value.filter(marker => (marker.fullyFree && marker.type === 'primary')).map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));
  const featuresFullySecondaries = allMarkers.value.filter(marker => (marker.fullyFree && marker.type === 'secondary')).map(marker => ({
    'type': 'Feature',
    'properties': {
      'title': marker.title,
      'type': marker.type,
      'urn': marker.urn,
    },
    'geometry': {
      'type': 'Point',
      'coordinates': marker.position
    }
  }));

  map.value.addSource('primaries', {
    'type': 'geojson',
    'data': {
      'type': 'FeatureCollection',
      'features': featuresPrimaries
    }
  });
  map.value.addSource('secondaries', {
    'type': 'geojson',
    'data': {
      'type': 'FeatureCollection',
      'features': featuresSecondaries
    }
  });

  map.value.addSource('fullyprimaries', {
    'type': 'geojson',
    'data': {
      'type': 'FeatureCollection',
      'features': featuresFullyPrimaries
    }
  });
  map.value.addSource('fullysecondaries', {
    'type': 'geojson',
    'data': {
      'type': 'FeatureCollection',
      'features': featuresFullySecondaries
    }
  });


  map.value.addLayer({
    'id': 'primaries',
    'type': 'circle',
    'source': 'primaries',
    'paint': {
      'circle-color': '#4264fb',
      'circle-radius': radius.value,
      'circle-stroke-width': 2,
      'circle-stroke-color': '#ffffff'
    }
  });

  map.value.addLayer({
    'id': 'secondaries',
    'type': 'circle',
    'source': 'secondaries',
    'paint': {
      'circle-color': '#E97451',
      'circle-radius': radius.value + 2,
      'circle-stroke-width': 3,
      'circle-stroke-color': '#ffffff'
    }
  });


  map.value.loadImage(
      '/img/star.png',
      (error, image) => {
        if (error) {
          throw error;
        }

        // Add the image to the map style.
        map.value.addImage('cat', image);
        const zoom = map.value.getZoom();

        map.value.addLayer({
          'id': 'fullyprimaries',
          'type': 'symbol',
          'source': 'fullyprimaries',
          'layout': {
            'icon-image': 'cat',
            'icon-size': zoom < 13 ? 0.1 : zoom < 14 ? 0.2 : 0.3
          }
        });
        map.value.addLayer({
          'id': 'fullysecondaries',
          'type': 'symbol',
          'source': 'fullysecondaries',
          'layout': {
            'icon-image': 'cat',
            'icon-size': zoom < 13 ? 0.1 : zoom < 14 ? 0.2 : 0.3
          }
        });
      });


  map.value.on('zoom', () => {
    // Adjust circle radius based on zoom level
    const zoom = map.value.getZoom();
    console.log(zoom);
    radius.value = zoom < 13 ? 8 : zoom < 14 ? 10 : 14; // Example logic for radius based on zoom
    starSize.value = zoom < 14 ? 0.1 : 0.2;
    map.value.setPaintProperty('primaries', 'circle-radius', radius.value);
    map.value.setPaintProperty('secondaries', 'circle-radius', radius.value + 2); // Slightly larger for secondaries
    map.value.setLayoutProperty('fullyprimaries', 'icon-size', starSize.value);
    map.value.setLayoutProperty('fullysecondaries', 'icon-size', starSize.value);

    drawSelectedHighlight();
  });


  ['primaries', 'secondaries'].forEach(filter => {
    map.value.on('click', filter, (e) => {
      map.value.flyTo({
        center: e.features[0].geometry.coordinates
      });
      selectedSchool.value = allMarkers.value.find(marker => marker.urn === e.features[0].properties.urn);
      drawSelectedHighlight();
      // map.value.setPaintProperty(filter, 'circle-stroke-width', 4);
    });


    // Change the cursor to a pointer when the it enters a feature in the 'circle' layer.
    map.value.on('mouseenter', filter, () => {
      map.value.getCanvas().style.cursor = 'pointer';
    });

    // Change it back to a pointer when it leaves.
    map.value.on('mouseleave', filter, () => {
      map.value.getCanvas().style.cursor = '';
    });

  })


}

const drawSelectedHighlight = () => {
  const e = selectedSchool.value;
  console.log(e);
  if (e && map.value) {
    // Remove any existing highlight layer
    if (map.value.getLayer('current-selected')) {
      map.value.removeLayer('current-selected');
    }
    if (map.value.getLayer('current-selected-star-primary')) {
      map.value.removeLayer('current-selected-star-primary');
    }
    if (map.value.getLayer('current-selected-star-secondary')) {
      map.value.removeLayer('current-selected-star-secondary');
    }
    // Add a new highlight layer for the clicked feature
    map.value.addLayer({
      'id': 'current-selected',
      'type': 'circle',
      'source': e.type == 'primary' ? 'primaries' : 'secondaries',
      'filter': ['==', 'urn', e.urn],
      'paint': {
        'circle-color': e.type === 'primary' ? '#4264fb' : '#E97451',
        'circle-radius': e.type === 'primary' ? radius.value : radius.value + 2,
        'circle-stroke-width': e.type === 'primary' ? radius.value - 2 : radius.value,
        'circle-stroke-color': '#0CEC91'
      }
    });
    console.log(starSize.value);
    map.value.addLayer({
      'id': 'current-selected-star-primary',
      'type': 'symbol',
      'source': 'fullyprimaries',
      'layout': {
        'icon-image': 'cat',
        'icon-size': starSize.value
      }
    });
    map.value.addLayer({
      'id': 'current-selected-star-secondary',
      'type': 'symbol',
      'source': 'fullysecondaries',
      'layout': {
        'icon-image': 'cat',
        'icon-size': starSize.value
      }
    });

  } else if ((map.value) && (map.value.getLayer('current-selected'))) {
    map.value.removeLayer('current-selected');
    map.value.removeLayer('current-selected-star-primary');
    map.value.removeLayer('current-selected-star-secondary');
  }
}


const clearSearch = () => {
  searchTerm.value = '';
  selectedSchool.value = null;
  filteredSchools.value = allMarkers.value; // Reset to all schools
  drawSelectedHighlight();
  filter(selectedFilter.value); // Reapply the current filter
};


</script>

<style>
.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 18px;
  height: 18px;

  border: 2px solid #333;
  border-radius: 100%;
  outline: none;
  cursor: pointer;
  position: relative;
}

.custom-radio:checked {
  background-color: #333;
}

.custom-radio:focus {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}
</style>
